import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44e08c39"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TariffUnique" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-400" }, "Загрузка тарифа...", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-red-400" }, "Произошла ошибка при загрузке тарифа", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "TariffUnique__header" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = {
  key: 0,
  class: "fas fa-check text-green-500 ml-2"
}
const _hoisted_9 = {
  key: 1,
  class: "fas fa-times text-red-500 ml-2"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "TariffUnique__body"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "mb-2 font-semibold" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { class: "grid grid-cols-2 gap-3 mb-2 mt-3" }
const _hoisted_20 = { class: "mb-2 font-semibold" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_tabs = _resolveComponent("tabs")!
  const _component_new_table = _resolveComponent("new-table")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_loading || _ctx.state.is_failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_3,
                _createVNode(_component_loader, { class: "primary mt-1" })
              ], 64))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_4,
                  _createVNode(_component_the_button, {
                    class: "primary small mt-2",
                    onClick: _ctx.loadUniqueTariff
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Перезагрузить ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_page_title, {
                title: `Уникальный тариф ${_ctx.getCompanyName}`
              }, null, 8, ["title"]),
              (_ctx.isVatEnabled)
                ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                : (_ctx.isVatDisabled)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                  : _createCommentVNode("", true)
            ]),
            _createVNode(_component_the_button, {
              class: "second small text",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
            }, {
              default: _withCtx(() => [
                _hoisted_10,
                _createTextVNode(" Назад ")
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_tabs, {
            tabs: _ctx.TABS,
            "is-sub-tab": "",
            "is-link": false,
            onClicked: _ctx.onTabClick,
            "is-small": ""
          }, null, 8, ["tabs", "onClicked"]),
          (_ctx.state.tariff)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_ctx.state.current_tab === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.TABLES[0].name), 1),
                      _createVNode(_component_new_table, {
                        class: "NewTable--bold",
                        columns: _ctx.UniqueTariffsOne,
                        "nested-rows": _ctx.TABLES[0].rows,
                        "nested-rows-expand-key": "shipmentCostDirection",
                        "expanded-rows": _ctx.state.expanded,
                        "is-bold": ""
                      }, {
                        "nested-td": _withCtx(({ column, row }) => [
                          (column.key === 'weight')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.getWeightTitle(row, _ctx.TABLES[0].rows)), 1)
                              ], 64))
                            : (column.key === 'minimumPrice')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(row.minimumPrice), 1))
                              : (column.key === 'cost')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(row.cost), 1))
                                : (
                                    column.key === 'action' &&
                                    row.shipmentCostDirection &&
                                    row.shipmentCostDirection.length
                                )
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 3,
                                      class: _normalizeClass([
                                        'flex items-center justify-center cursor-pointer select-none',
                                    ]),
                                      onClick: ($event: any) => (_ctx.toggleRow(row))
                                    }, [
                                      _createElementVNode("i", {
                                        class: _normalizeClass(["fas fa-chevron-down transition-all mr-2", { 'fa-rotate-180': _ctx.isExpanded(row.id) }])
                                      }, null, 2)
                                    ], 8, _hoisted_16))
                                  : _createCommentVNode("", true)
                        ]),
                        "nested-row-td": _withCtx(({ row, column }) => [
                          (column.key === 'weight')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(row.fromCity ? row.fromCity.name : '-') + " - " + _toDisplayString(row.whereCity ? row.whereCity.name : '-'), 1)
                              ], 64))
                            : (column.key === 'minimumPrice')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(row.minimumPrice), 1))
                              : (column.key === 'cost')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(row.cost), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["columns", "nested-rows", "expanded-rows"]),
                      _createElementVNode("div", _hoisted_19, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tablesSecond, (table) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `table-${table.id}`
                          }, [
                            _createElementVNode("p", _hoisted_20, _toDisplayString(table.name), 1),
                            _createVNode(_component_new_table, {
                              class: "NewTable--bold",
                              columns: _ctx.UniqueTariffsOne,
                              "nested-rows": table.rows,
                              "nested-rows-expand-key": "shipmentCostDirection",
                              "expanded-rows": _ctx.state.expanded,
                              "is-bold": ""
                            }, {
                              "nested-td": _withCtx(({ column, row }) => [
                                (column.key === 'weight')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.getWeightTitle(row, table.rows)), 1)
                                    ], 64))
                                  : (column.key === 'minimumPrice')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(row.minimumPrice), 1))
                                    : (column.key === 'cost')
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(row.cost), 1))
                                      : (
                                            column.key === 'action' &&
                                            row.shipmentCostDirection &&
                                            row.shipmentCostDirection.length
                                        )
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 3,
                                            class: _normalizeClass([
                                                'flex items-center justify-center cursor-pointer select-none',
                                            ]),
                                            onClick: ($event: any) => (_ctx.toggleRow(row))
                                          }, [
                                            _createElementVNode("i", {
                                              class: _normalizeClass(["fas fa-chevron-down transition-all mr-2", { 'fa-rotate-180': _ctx.isExpanded(row.id) }])
                                            }, null, 2)
                                          ], 8, _hoisted_23))
                                        : _createCommentVNode("", true)
                              ]),
                              "nested-row-td": _withCtx(({ row, column }) => [
                                (column.key === 'weight')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.getDirection(row)), 1)
                                    ], 64))
                                  : (column.key === 'minimumPrice')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(row.minimumPrice), 1))
                                    : (column.key === 'cost')
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(row.cost), 1))
                                      : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["columns", "nested-rows", "expanded-rows"])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.tariff_second && _ctx.state.current_tab === 2)
                  ? (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
                      key: 1,
                      loading: _ctx.state.is_loading
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_the_table, {
                          loading: _ctx.state.is_loading,
                          columns: _ctx.StandardParamsColumns,
                          rows: _ctx.StandardParamsRows
                        }, {
                          td: _withCtx(({ row, column, key }) => [
                            (column.key === 'description')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (row.name === 'packPrice')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" Терминальная обработка (₸) ")
                                      ], 64))
                                    : (row.name === 'orderPrice')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(" Сбор за оформление заказа (₸) ")
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                          _createTextVNode(_toDisplayString(`${row.description} ${_ctx.getSign(row.name)}`), 1)
                                        ], 64))
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.state.tariff_second[_ctx.getParamsIndex(key)]?.amount), 1)
                                ], 64))
                          ]),
                          _: 1
                        }, 8, ["loading", "columns", "rows"])
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true),
                (
                        _ctx.state.tariff_third && _ctx.state.tariff_third.length && _ctx.state.current_tab === 3
                    )
                  ? (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
                      key: 2,
                      loading: _ctx.state.is_loading
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_the_table, {
                          loading: _ctx.state.is_loading,
                          columns: _ctx.AdditionalServicesColumns,
                          rows: _ctx.state.tariff_third
                        }, {
                          td: _withCtx(({ row, column }) => [
                            (column.key === 'name')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.AdditionalServicesEnum[row.name]), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(row[column.key]), 1)
                                ], 64))
                          ]),
                          _: 1
                        }, 8, ["loading", "columns", "rows"])
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}